module.exports = __webpack_public_path__ + "media/images/judge_hammer-f7229e901219a0061d5353c4262a97f9.png";